<script setup lang="ts">
import type { Course, CoursesResponse } from '~~/shared/types/course'

const { data } = useAsyncData(
  'infoanlaesse',
  () => $fetch<CoursesResponse>('/api/courses', { query: { slug: 'informationsanlass' } }),
  {
    server: false,
    lazy: true,
    default: () => ({ courses: [] }),
    getCachedData: () => undefined
  }
)

const events = computed(() => data.value?.courses ?? [])

function formatDate(value: string): string {
  if (!value) return ''
  return new Date(value).toLocaleDateString('de-CH', {
    weekday: 'short', day: '2-digit', month: 'long', year: 'numeric'
  })
}

function formatTime(value: string): string {
  if (!value) return ''
  return new Date(value).toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' })
}

function eventStart(course: Course): string {
  return course.sessions?.[0]?.startdatetime ?? course.startdate
}

function eventEnd(course: Course): string | null {
  return course.sessions?.[0]?.enddatetime ?? null
}
</script>

<template>
  <UPageSection
    v-if="events.length"
    title="Informationsanlässe"
    description="Du hast Fragen? Lerne uns unverbindlich an einem Informationsanlass kennen."
  >
    <div class="flex flex-col gap-3">
      <UCard
        v-for="course in events"
        :key="course.id"
      >
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2 font-medium">
              <UIcon
                name="i-lucide-calendar-clock"
                class="text-primary shrink-0"
              />
              <span>
                {{ formatDate(eventStart(course)) }}
                <template v-if="eventEnd(course)">, {{ formatTime(eventStart(course)) }} – {{ formatTime(eventEnd(course)!) }} Uhr</template>
              </span>
            </div>
            <p class="text-sm text-muted">
              {{ course.title }}
            </p>
          </div>
          <UButton
            :to="`/anmeldung?kurs=${course.id}`"
            trailing-icon="i-lucide-arrow-right"
            class="shrink-0 w-full sm:w-auto justify-center"
          >
            Anmelden
          </UButton>
        </div>
      </UCard>
    </div>
  </UPageSection>
</template>
